import { render, staticRenderFns } from "./sortItem.vue?vue&type=template&id=17f909c1"
import script from "./sortItem.vue?vue&type=script&lang=js"
export * from "./sortItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports